import React,{Component} from 'react';
import { 
  Collapse,
  FormGroup,
  Label,
  Input,
  FormText
} from 'reactstrap';

import InfoTooltip from '../InfoTooltip';

import capitalize from 'lodash/capitalize';

class RadioButtonAccordion extends Component {
  constructor(){
    super();

    this.state ={
      value:null
    }
  }

  componentWillMount(){
    if(this.props.defaultValue){
      this.setState({value:this.props.defaultValue});
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.defaultValue !== this.props.defaultValue){
      this.setState({value:nextProps.defaultValue});
    }
  }

  handleRadioButtonClick(event,section){
    this.setState({value:section.name});
    if(this.props.onChange){
      this.props.onChange();
    }
  }

  render(){
    const { value } = this.state,
      { sections, name } = this.props;

    return (
      <div>
        {sections.map((section,i) => (
          <div key={i}>
            <FormGroup check>
              <Label check>
                <Input 
                  type="radio" 
                  name={name}
                  value={section.name}
                  checked={value === section.name} 
                  onClick={(event) => this.handleRadioButtonClick(event,section)} 
                />
                &nbsp;&nbsp;{section.display || capitalize(section.name)}
                {section.tooltip && (
                  <InfoTooltip text={section.tooltip} />
                )}
              </Label>
            </FormGroup>
            {section.renderSection && (
              <Collapse isOpen={value === section.name}>
                <div style={{marginTop:5,marginLeft:26}}>
                  {section.renderSection()}
                </div>
              </Collapse>
            )}
          </div>
        ))}
      </div>
    )
  }
}

export default RadioButtonAccordion;



// WEBPACK FOOTER //
// ./src/shared/components/RadioButtonAccordion/index.js